import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Navbar } from '@/components/Navbar';
import { Portfolio } from '@/components/Portfolio';
import { Footer } from '@/components/Footer';
import { WhatsAppFloat } from '@/components/WhatsAppFloat';
import { Reveal } from '@/components/Reveal';
import { CalculatorCard } from '@/components/CalculatorCard';

export default function PortfolioPage() {
  const { category } = useParams();

  useEffect(() => {
    document.title = 'Portfolio | Events by AJ — Event Planner in Hyderabad';
    window.scrollTo(0, 0);
  }, [category]);

  return (
    <div className="bg-ink text-cream min-h-screen">
      <div className="grain-overlay" aria-hidden="true" />
      <Navbar />
      <main className="pt-16">
        <Portfolio initialFilter={category} />
        {category === 'birthdays' && (
          <section data-testid="birthday-calculator-embed" className="py-24 border-t border-white/10">
            <div className="max-w-3xl mx-auto px-5 sm:px-8">
              <Reveal className="text-center">
                <p className="caption-label mb-4">Instant Estimate</p>
                <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl font-light tracking-tight text-cream">
                  Price your <span className="italic text-champagne">birthday decor</span>
                </h2>
              </Reveal>
              <Reveal delay={0.1} className="mt-12">
                <CalculatorCard />
              </Reveal>
            </div>
          </section>
        )}
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}
